import { XIcon } from 'lucide-react'
import { memo, type ReactNode } from 'react'

import { Button } from '@/components/ui/button'

import type { DataTableFilter } from './data-table.interface'
import { DataTableFilterDropdown } from './data-table-filter-dropdown.atom'

interface DataTableToolbarFiltersProps {
  filterList: DataTableFilter[]
  hasActiveFilters: boolean
  getFilterValues: (filterId: string) => string[]
  onFilterChange: (filterId: string, valueList: string[]) => void
  onClearFilters: () => void
}

/**
 * Renders filter dropdowns and a reset button for the data table toolbar.
 */
const DataTableToolbarFiltersBase: React.FC<DataTableToolbarFiltersProps> = ({
  filterList,
  hasActiveFilters,
  getFilterValues,
  onFilterChange,
  onClearFilters,
}): ReactNode => (
  <>
    {filterList.map((filter) => (
      <DataTableFilterDropdown
        key={filter.id}
        filter={filter}
        selectedValueList={getFilterValues(filter.id)}
        onChange={(valueList) => onFilterChange(filter.id, valueList)}
      />
    ))}
    {hasActiveFilters && (
      <Button
        variant="ghost"
        size="sm"
        className="data-table-clear-filters h-8 px-2 lg:px-3"
        onClick={onClearFilters}
      >
        Reset
        <XIcon className="ml-2 size-4" />
      </Button>
    )}
  </>
)

export const DataTableToolbarFilters = memo(DataTableToolbarFiltersBase)

DataTableToolbarFilters.displayName = 'DataTableToolbarFilters'
